<script lang="ts" setup>
import InvestorHero from '@/domains/investor/components/Hero/Hero.vue'
import FileList from '~/domains/investor/components/FileList/FileList.vue'

const { t, locale } = useI18n()

useHead(() => ({
  title: t('pageTitles.companyForms.title'),
  meta: [
    {
      name: 'description',
      content: t('pageTitles.companyForms.meta'),
    },
  ],
  link: [
    {
      hid: 'favicon',
      rel: 'icon',
      type: 'image/x-icon',
      href: '/favicon.ico',
    },
    {
      rel: 'canonical',
      href: t(`pageTitles.companyForms.canonical.${locale.value}`),
    },
    {
      rel: 'alternate',
      hreflang: 'pl',
      href: t('pageTitles.companyForms.canonical.pl'),
    },
    {
      rel: 'alternate',
      hreflang: 'en',
      href: t('pageTitles.companyForms.canonical.en'),
    },
    {
      rel: 'alternate',
      hreflang: 'x-default',
      href: t('pageTitles.companyForms.canonical.pl'),
    },
  ],
}))
</script>

<template>
  <div class="contact-forms-page">
    <InvestorHero
      :title="$t('contact.forms.hero.header')"
      image="/images/contact/hero.png"
    />

    <UiSection
      id="forms-multisport"
      class="forms-multisport"
      color="white"
    >
      <div class="section__container">
        <div class="section__row">
          <div class="section__col">
            <UiHeader
              v-if="$t('contact.forms.section1.header')"
              position="center"
              :header-size="'h5'"
              :subheader-size="'body-1'"
              :header="$t('contact.forms.section1.header')"
              :subheader="$t('contact.forms.section1.subheader')"
            />
          </div>
        </div>

        <div class="section__row">
          <div class="section__col">
            <FileList
              :show-title="false"
              :variant="'list'"
              :request-id="'dla-firmy-formularze-formularze-multisport'"
            />
          </div>
        </div>
      </div>
    </UiSection>

    <UiSection
      id="forms-multilife"
      class="forms-multilife"
      color="white"
    >
      <div class="section__container">
        <div class="section__row">
          <div class="section__col">
            <UiHeader
              v-if="$t('contact.forms.section2.header')"
              :header-size="'h5'"
              position="center"
              :header="$t('contact.forms.section2.header')"
              :subheader="$t('contact.forms.section2.subheader')"
            />
          </div>
        </div>

        <div class="section__row">
          <div class="section__col">
            <FileList
              :variant="'list'"
              :show-title="false"
              :request-id="'dla-firmy-formularze-formularze-multilife'"
            />
          </div>
        </div>
      </div>
    </UiSection>
  </div>
</template>

<style lang="scss" scoped>
.forms-multilife {
  padding-top: 0;
}
</style>
